// extracted by mini-css-extract-plugin
module.exports = {"container":"Main__container___3DPk9","row":"Main__row___2QWlc","extra-chats":"Main__extra-chats___10fRf","extra-chat-row":"Main__extra-chat-row___3X4D_"};